module.exports = __webpack_public_path__ + "img/grey-webinars-2.19ece732.png";